module.exports = __webpack_public_path__ + "img/img3.04c98a04.png";